// src/components/krums/CrisolKrums.js
import React, { useState, useEffect } from 'react';
import { getSaldo } from '../../services/api';

const CrisolKrums = () => {
  const [saldo, setSaldo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [esBeta, setEsBeta] = useState(false);

  useEffect(() => {
    cargarSaldo();
    // Verificar si es beta (por ejemplo, por el rol en localStorage)
    const user = JSON.parse(localStorage.getItem('@kreamun:user') || '{}');
    setEsBeta(user.rol === 'beta');
  }, []);

  const cargarSaldo = async () => {
    try {
      const response = await getSaldo();
      setSaldo(response.data.saldo);
    } catch (error) {
      console.error('Error cargando saldo:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="crisol-krums">
      <h3>🔮 Crisol de Krums</h3>
      
      {/* ⚠️ AVISO PARA BETA TESTERS */}
      {esBeta && (
        <div className="aviso-beta">
          <div className="aviso-icono">🧪</div>
          <div className="aviso-texto">
            <strong>Modo Beta Tester</strong>
            <p>Las imágenes generadas son <strong>ilustrativas</strong> y pueden no coincidir exactamente con el texto de la historia. ¡Disfruta probando!</p>
          </div>
        </div>
      )}
      
      <div className="saldo-krums">
        <div className="krums-comprados">
          <span className="label">⚡ Comprados:</span>
          <span className="valor">{saldo?.krums_comprados || 0}</span>
        </div>
        <div className="krums-gratis">
          <span className="label">✨ Gratis:</span>
          <span className="valor">{saldo?.krums_gratis || 0}</span>
        </div>
        <div className="imagenes-restantes">
          <span className="label">🖼️ Imágenes:</span>
          <span className="valor">{saldo?.imagenes_restantes || 0}</span>
        </div>
      </div>
    </div>
  );
};

export default CrisolKrums;